export type Device = {
    merchant_id: string;
    merchant_name: string;
    lsn: string;
    alias: string;
    status: DeviceStatus;
    type: DeviceType;
    created_at: string;
    updated_at: string;
	  created_at_time_zone: string
    updated_at_time_zone: string
}

export enum DeviceStatus {
  ACTIVATED = 'Activated',
  PENDING = 'Pending Activation',
  DESACTIVATED = 'Desactivate'
}

export enum DeviceType {
  SMARTPOS = 'smartpos',
  SOFTPOS = 'softpos'
}

export type DeviceCheckboxFilter = {
  merchants: string[];
  devices: string[];
}

export type DeviceFilter = {
  query?: string;
  checkboxes?: {
    status?: any;
    type?: any;
    merchants?: any;
    devices?: any;
  }
}